import {useContext} from "react";
import PaginationContext from "./context";

function usePagination() {
  return useContext(PaginationContext);
}

export default usePagination;
